import { render, staticRenderFns } from "./copy-clipboard.vue?vue&type=template&id=aa69b07e&scoped=true&"
import script from "./copy-clipboard.ts?vue&type=script&lang=ts&"
export * from "./copy-clipboard.ts?vue&type=script&lang=ts&"
import style0 from "./copy-clipboard.scss?vue&type=style&index=0&id=aa69b07e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa69b07e",
  null
  
)

export default component.exports